
import { useSplide } from '~/lib/splide'
import { Grid }  from "@splidejs/splide-extension-grid"  

document.addEventListener('DOMContentLoaded', () => { 

  useSplide('#mision-vision', {
    pauseOnHover: false,
    arrows: false,
    perPage: 2,
    drag: false,
    gap: '5rem',
    pagination: false,
    breakpoints: {
      768: {
        perPage: 1, 
        gap: '1rem',
        drag: true,
        pagination: true,
        padding: {
          right: '3rem', // Espaciado a la derecha 
        },
        autoplay: true,
        interval: 5000,
        rewind: true,
      }
    }
  })
    ?.then((splide) => {
      splide?.mount()
    })

    // Slider para Valores con Grid
  useSplide("#values-slider", { 
    pagination: false,
    arrows: false,
    drag: false,
    gap: "1rem", 
    grid: {
      rows: 3,
      cols: 2,
      gap: {
        row: "1rem", // Espaciado entre filas
        col: "1rem", // Espaciado entre columnas
      },
    },
    breakpoints: {
      768: { 
        grid: {
          rows: 1,
          cols: 1,
          gap: {
            row: "1rem", // Espaciado entre filas
            col: "1rem", // Espaciado entre columnas
          },
        },
        padding: { 
          right: "5rem", 
        },
        rewind: true,
        gap: "1rem",
        pagination: true,
        drag: true,
        autoplay: true,
        interval: 3000,
      },
    },
  })
    ?.then((splide) => {
      splide?.mount({ Grid });
    });

  })